export default "__VITE_ASSET__D$cfuJeP__"